export default __webpack_public_path__ + "images/hand_baggage.db14c19.svg";